import React from 'react'
import { Row, Col } from 'react-bootstrap';
import '../Allexperiences/Allexperiences.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css'; 
import 'swiper/css/navigation';
import 'swiper/css/pagination'; 


import belalogo from '../../../assets/Navbar/logo.png'

import Wildlife from '../../../assets/Allexperieance/wildlife.webp';
import innervoice from '../../../assets/Allexperieance/inner-voice.webp';
import personaltransformation from '../../../assets/Allexperieance/personaltransformation.webp';
import naturetheorapy from '../../../assets/Allexperieance/naturetheropy.webp';
import Meaning from '../../../assets/Allexperieance/meaning.webp';
import timestill from '../../../assets/Allexperieance/timestill.webp';
import backintime from '../../../assets/Allexperieance/backintime.webp';
import recreatememory from '../../../assets/Allexperieance/recreatememory.webp';
import atithidevobhav from '../../../assets/Allexperieance/atithidevobhav.webp';
import childhoodmemory from '../../../assets/Allexperieance/childhoodmemories.webp';



function Allexperiences() {

  const contentArray = [
    {
      id: 1,
      heading: "Wildlife of Sindhudurg",
      paragraph: 'The Olive Ridley turtle (Lepidochelys olivacea) is a small, endangered sea turtle species known for its mass nesting behavior called "arribada." Vengurla, a coastal town in Maharashtra, India, is one of the nesting sites for these turtles. Every year, during the nesting season (usually from November to April), female Olive Ridley turtles come ashore on the beaches of Vengurla to lay eggs. Local conservation efforts, along with community involvement, help protect these turtles and their hatchlings, as they face threats from habitat destruction, fishing nets, and poaching.',
      image:Wildlife
    },
    {
      id: 2,
      heading: "...listening to your inner voice",
      paragraph: "At our estate, the rhythmic symphony of waves serves as a backdrop, inviting residents to an intimate conversation with their inner selves. In the tranquil embrace of nature's simplicity, the gentle lull of the tide becomes a meditative melody, harmonizing with the whispers of one's inner voice. The environment fosters a sense of stillness, a rare sanctuary where the external noise of the world dissipates. Amidst this natural canvas, individuals find the perfect setting to introspect, to attune their thoughts to the cadence of the sea, and to engage in a profound dialogue with their innermost thoughts and desires.",
      image:innervoice
    },
    {
      id: 3,
      heading: "Self awareness and personal transformation...",
      paragraph: "Living under the canopy of coconut trees, residents are immersed in a tranquil cocoon that encourages mindfulness. The absence of urban clamor allows for a more profound connection with one's intuition, guiding individuals to listen attentively to the whispers of their own aspirations, dreams, and inner wisdom. Whether during morning strolls along the beach or quiet moments of contemplation under the shade of coconut palms, our estate becomes a sanctuary for self-discovery.",
      image:personaltransformation
    },
    {
      id: 4,
      heading: "Atithi Devo Bhava",
      paragraph: 'Belantara encapsulates the essence of Indian hospitality, emphasizing the sacred nature of welcoming guests. Imagine a tranquil beach estate where this philosophy is not just a saying but a way of life. Nestled along the pristine shores, BBE harmoniously blends luxury with a heartfelt commitment to treating every visitor as a revered guest. The waves serenade a rhythmic welcome, inviting travelers into a haven where the ethos of "Atithi Devo Bhava" unfolds with each passing moment.',
      image:atithidevobhav
    },
    {
      id: 5,
      heading: "Therapy Through Nature",
      paragraph: "Our estate is inherently therapeutic due to its serene environment, with the rhythmic sound of waves up close promoting relaxation. The fresh sea breeze and warm sunlight trickling through the canopy of coconut trees contribute to a calming atmosphere, reducing stress and enhancing overall well-being. The expansive views of the sea can also provide a sense of tranquility and escapism, offering a therapeutic retreat from the demands of everyday life. The towering palms provide a constant, soothing rustle of leaves, creating a serene ambiance.",
      image:naturetheorapy
    },
    {
      id: 6,
      heading: belalogo,
      paragraph: "Belantara is a word from the ancient Sanskrit language and is also a commonly used term in Indonesian. It translates to 'jungle' or 'wilderness' in English and refers to a dense area typically found in tropical climates.",
      para1:"In Sanskrit,",
      para2:'“Bela” means “Forest.”',
      para3:'“Antara” means “Inside.”',
      image:Meaning
    },
    {
      id: 7,
      heading: "Where time stands still...",
      paragraph: "Experience moments that are so captivating, memorable, or emotionally soothing that they seem to extend beyond the normal flow of time. You are sure to feel as if the world around you has momentarily ceased to move forward. Certain moments are so profound or significant that they create a sense of timelessness. It can be associated with feelings of deep connection, intense joy, profound beauty, and inner peace.",
      image:timestill
    },
    {
      id: 8,
      heading: "Travel Back in Time",
      paragraph: "Nestled in the serene embrace of a rural off-grid setting, BBE becomes a captivating portal, seamlessly connecting the present with the echoes of a bygone era. As the rhythmic waves kiss the untouched shores, one is transported back in time, enveloped by the simplicity and authenticity of a world untouched by the hustle of modernity. Far removed from the digital humdrum and an urban concrete jungle, BBE offers an immersive experience reminiscent of a time when life unfolded at a slower pace. The absence of city lights unveils a night sky adorned with stars, evoking a celestial panorama that mirrors the nights of yesteryears, sparking a sense of wonder and connection to a simpler cosmos.",
      image:backintime
    },
    {
      id: 9,
      heading: "Relive Your Childhood Memories",
      paragraph: "We believe that childhood memories are treasures. Reconnect with your inner child by enjoying classic outdoor games you loved growing up",
      image:childhoodmemory,
      table: [
        { column1: "Kite Flying :", column2: "Feel the wind in your hair and the thrill of your kite soaring high above the sea." },
        { column1: "Lagori (Seven Stones):", column2: "Relive the excitement of this classic game of skill and agility with friends and family." },
        { column1: "Top Spinning (Lattu):", column2: "Test your coordination and bring back the challenge of mastering the spinning top." },
        { column1: "Marbles (Goli):", column2: "Experience the simple joy of this traditional game that sparked so much laughter and competition." },
        { column1: "Wheel and Stick:", column2: "Race along the beach or garden paths with this timeless activity that’s sure to spark joy." },
        { column1: "Lemon and Spoon Race:", column2: "Challenge your balance and focus as you race against others in this playful contest." }
      ]
    },
    {
      id: 10,
      heading: "Recreate New Memories",
      paragraph: "In today’s digital age, it’s easy to get lost in solo screen time with mobile apps and OTT platforms wherever you go. However, engaging in board games and outdoor group activities offers a refreshing alternative that fosters genuine connections. These interactive experiences encourage teamwork, communication, and laughter, making them perfect for bonding with family, friends, or colleagues. Stepping away from screens not only enhances relationships but also creates lasting memories, turning ordinary moments into extraordinary ones. Embrace the joy of shared experiences and strengthen your connections through play!",
      image:recreatememory
    }
  ];
  return (
    <>
    <section className='allexperience pb-5 px-md-5 px-3 d-flex flex-column'>
      <div className='pb-4'>
        <h3 className="section-heading pb-4 text-center">
          An unprecedented experience ... 
        </h3>

        <div>
          <Row className="g-4">
            <Col md={6}>
              <div className=" text-white">
                <p>
                  Welcome to Belantara, our private beach estate, where guests are
                  invited to immerse themselves in an unparalleled experience of
                  serenity and nature, nestled in the rustic and historic Sindhudurg
                  district of southern Maharashtra, just north of Goa.
                </p>
                <p>
                  Our location is truly unique on the Indian coastline, offering a
                  rare combination of privacy, an exclusive beach, and unspoiled
                  wilderness. Belantara is ideal for those seeking tranquility,
                  seclusion, and a deep connection with nature. Whether you’re
                  looking for a single cottage, suite, villa, or the opportunity to
                  have the entire estate exclusively to yourself, we offer the
                  perfect setting for your retreat.
                </p>
              </div>
            </Col>

            <Col md={6}>
              <div className=" text-white">
                <p>
                  At Belantara, your stay can be as peaceful or as invigorating as
                  you wish. Whether you prefer unwinding in solitude, free of
                  schedules, or exploring an extraordinary range of wellness
                  programs and outdoor activities, every moment spent here promises
                  to be memorable.
                </p>
                <p>
                  Though secluded and entirely "off-grid," Belantara remains
                  conveniently accessible. We are just 25 minutes from Sindhudurg
                  Airport (SDW) and 90 minutes from the new North Goa Mopa Manohar
                  International Airport (GOX), allowing you to enjoy seclusion
                  without isolation.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className='databox container-fluid p-0 m-0'>
        <Swiper
          modules={[Navigation, Pagination]} 
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          pagination={false}
          navigation={true}
        >
          {contentArray.map((item, index) => (
            <SwiperSlide key={index}>
              <div id={`slide-${index}`}>
                <Row className='g-0'>
                  <Col lg={7} className='overflow-hidden imagebox'>
                    <img src={item.image} alt='img' className='img-fluid' loading='lazy'/>
                  </Col>
                  <Col lg={5} className="d-flex flex-column align-items-center justify-content-center content-column ">
                    <div className="p-md-5 p-3 allexpertiesdivtext">
                      {item.id === 6 ? (
                        <>
                          <img
                            src={item.heading}
                            alt="Slide Heading"
                            className="img-fluid slideimg"
                            loading='lazy'
                          />
                          <div>
                            <p>{item.paragraph}</p>
                            <p>{item.para1}</p>
                            <p>{item.para2}</p>
                            <p>{item.para3}</p>
                          </div>
                        </>
                      ) : (
                        <div>
                          <h2 className="text-start">{item.heading}</h2>
                          <p>{item.paragraph}</p>
                          {item.id === 9 && item.table && (
                            <div className='table-container table-responsive allexperieancetable'>
                            <table className="table">
                              <tbody>
                                {item.table.map((row, rowIndex) => (
                                  <tr key={rowIndex}>
                                    <td>{row.column1}</td>
                                    <td>{row.column2}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  </>
  )
}

export default Allexperiences